<template>
  <form @submit.prevent="handleSubmit(onSubmit)">
    <div class="row">

      <div class="col-4">

        <div class="form-group row">
          <label :for="id + '-packagingCode-identifier'" class="col-3 col-form-label">{{ $t('packaging-code.identifier') }}</label>
          <div class="col-9">
            <e-form-text :id="id + '-packagingCode-identifier'" :value="entity.identifier"/>
          </div>
        </div>

      </div>

      <div class="col-4">

        <div class="form-group row">
          <label :for="id + '-packagingCode-name'" class="col-3 col-form-label">{{ $t('packaging-code.label') }}</label>
          <div class="col-9">
            <e-form-text :id="id + '-packagingCode-name'" :value="entity.name"/>
          </div>
        </div>

      </div>

      <div class="col-4">


      </div>

    </div>
  </form>
</template>

<script>

import service from "@/services/packagingCode.service";
import {log} from "@emons/emons-vue"

export default {
  name: "PackagingCodeView",
  components: {},
  mounted() {
    log('debug', 'Mounted PackagingCodeView...')
    this.getEntityDetails()
  },
  props: {
    id: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      entity: {
        abbreviation: null,
        name: null
      }
    }
  },
  methods: {
    getEntityDetails: function () {
      this.$emit('enableSpinner');
      service
          .getEntityDetails(this.link)
          .then(response => {
            this.entity = response.data
            this.$emit('disableSpinner');
          })
    }
  }
}
</script>

<style scoped>

</style>